/* eslint no-inline-comments: 0 */

const Lists = () => import( /* webpackChunkName: "group-subscriptions" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-subscriptions" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-subscriptions" */ `./edit.vue` );
const Settings = () => import( /* webpackChunkName: "group-subscriptions" */ `./settings.vue` );
const AddOns = () => import( /* webpackChunkName: "group-subscriptions" */ `./add-ons.vue` );

const ListPromotionCodes = () => import( /* webpackChunkName: "group-subscriptions" */ `./promotion-codes/list.vue` );
const AddPromotionCode = () => import( /* webpackChunkName: "group-subscriptions" */ `./promotion-codes/add.vue` );

export default {
	path: `plans`,
	children: [
		{
			path: ``,
			name: `list-subscriptions`,
			component: Lists,
			meta: {
				title: `Plans`
			}
		},
		{
			path: `settings`,
			name: `subscription-settings`,
			component: Settings,
			meta: {
				title: `Subscription Settings`
			}
		},
		{
			path: `add-ons`,
			name: `subscription-add-ons`,
			component: AddOns,
			meta: {
				title: `Add-ons`
			}
		},
		{
			path: `new`,
			name: `add-subscription`,
			component: Add,
			meta: {
				title: `Add Plan`
			}
		},
		{
			path: `promotion-codes`,
			name: `list-promotion-codes`,
			component: ListPromotionCodes,
			meta: {
				title: `Promotion Codes`
			}
		},
		{
			path: `promotion-codes/new`,
			name: `add-promotion-code`,
			component: AddPromotionCode,
			meta: {
				title: `Add Promotion Code`
			}
		},
		{
			path: `:uuid`,
			name: `edit-subscription`,
			component: Edit,
			meta: {
				title: `Edit Plan`
			}
		}
	]
};
